<template>
  <metainfo>
    <template #title="{ content }">{{ content ? `${content}` : `${appName}` }}</template>
    <template #description="{ content }">{{ content }}</template>
  </metainfo>

  <Header />



  <main>
    <router-view />
  </main>
  <Footer />
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import { provide } from 'vue'

import { useMeta } from 'vue-meta'

export default {
  name: 'App',
  components: {
    Header,
    Footer,
  }, 
  setup() {

    // const { tm } = useI18n()

    // Global Vars
    const globalVars = {
      appName: 'Reisebüro Burkhard',
      appUrl: process.env.VUE_APP_URL,
      googleAnalyticsId: process.env.VUE_APP_GOOGLE_ANALYTICS_ID,
      social: {
        twitter: {
          acc: '@fullstackplanet',
          uri: 'https://twitter.com/FullStackPlanet'
        },
      },
      prismicApiEndpoint: process.env.VUE_APP_PRISMIC_API_ENDPOINT,
      prismicRepoName: process.env.VUE_APP_PRISMIC_REPO_NAME,
      env: process.env.VUE_APP_ENV,
    }
    provide('globalVars', globalVars);

    // Vue Meta
    const defaultTitle = `${globalVars.appName} Ihr Reisebüro für Fürstenfeldbruck und Umgebung`
    const defaultDescription = 'Ihr lokales Reisebüro in Mammendorf für Traumurlaube weltweit! Maßgeschneiderte Auslandsreisen & Erlebnisse. Jetzt buchen & unvergessliche Momente genießen!'
    const baseUrl = globalVars.appUrl || 'https://www.reisebuero-burkhard.de'
    const ogImage = `${baseUrl}/og-image.png`

    useMeta({
      title: defaultTitle,
      htmlAttrs: { lang: 'de-DE', amp: false },
      description: defaultDescription,
      meta: [
        // Open Graph
        { property: 'og:title', content: `${globalVars.appName} - Ihr Reisebüro in Mammendorf` },
        { property: 'og:description', content: defaultDescription },
        { property: 'og:url', content: `${baseUrl}/` },
        { property: 'og:image', content: ogImage },
        { property: 'og:image:width', content: '1200' },
        { property: 'og:image:height', content: '630' },
        { property: 'og:image:alt', content: `${globalVars.appName} - Ihr Reisebüro in Mammendorf` },
        { property: 'og:site_name', content: globalVars.appName },
        { property: 'og:locale', content: 'de_DE' },
        { property: 'og:type', content: 'website' },
        // Twitter Card
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:title', content: `${globalVars.appName} - Ihr Reisebüro in Mammendorf` },
        { name: 'twitter:description', content: defaultDescription },
        { name: 'twitter:image', content: ogImage },
        { name: 'twitter:image:alt', content: `${globalVars.appName} - Ihr Reisebüro in Mammendorf` },
      ],
      link: [
        { rel: 'canonical', href: `${baseUrl}/` },
      ],
      script: [
        {
          type: 'application/ld+json',
          innerHTML: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'TravelAgency',
            '@id': `${baseUrl}/#organization`,
            'name': 'Reisebüro Burkhard',
            'url': baseUrl,
            'logo': ogImage,
            'image': ogImage,
            'description': defaultDescription,
            'address': {
              '@type': 'PostalAddress',
              'streetAddress': 'Augsburger Str. 8',
              'addressLocality': 'Mammendorf',
              'postalCode': '82291',
              'addressRegion': 'Bayern',
              'addressCountry': 'DE'
            },
            'geo': {
              '@type': 'GeoCoordinates',
              'latitude': 48.2008,
              'longitude': 11.1592
            },
            'telephone': '+49 8145 1591',
            'email': 'info@reisebuero-burkhard.de',
            'areaServed': ['Mammendorf', 'Fürstenfeldbruck'],
            'openingHoursSpecification': [
              {
                '@type': 'OpeningHoursSpecification',
                'dayOfWeek': ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
                'opens': '09:00',
                'closes': '17:00'
              }
            ],
            'priceRange': '€€',
            'sameAs': [
              'https://www.instagram.com/reisebuero_burkhard_'
            ],
            'hasMap': 'https://www.google.com/maps?q=Augsburger+Str.+8,+82291+Mammendorf'
          })
        }
      ],
    })

  }
}

</script>
